import { render } from "./InventorySupplierView.vue?vue&type=template&id=7b01b03f&scoped=true"
import script from "./InventorySupplierView.vue?vue&type=script&lang=js"
export * from "./InventorySupplierView.vue?vue&type=script&lang=js"

import "./InventorySupplierView.vue?vue&type=style&index=0&id=7b01b03f&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7b01b03f"]])

export default __exports__